// Author: T4professor

import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams, ICellEditorParams } from "ag-grid-community";
import { AuthenticationService } from "src/app/auth/authentication.service";

export interface ICustomCellEditorParams {
  data: any;
  rowData: any;
}
@Component({
  selector: "app-status-renderer",
  template: `<span
    *ngIf="value"
    class="p-tag p-component cursor-edit my-2"
    [attr.style]="
      'background-color:' + colorCode + '50 !important;' + 'color:' + colorCode
    "
  >
    <span *ngIf="isString !== 'string'" class="p-tag-value text-dark">{{
      label
    }}</span>
    <span *ngIf="isString == 'string'" class="p-tag-value text-dark">{{
      value.label
    }}</span>
  </span>`,
  standalone: false,
})
export class StatusRendererComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams & ICellEditorParams;
  value: any;
  colorCode: any;
  statusList: any = null;
  label = "";
  isString!: string;
  addonFeature: any;
  displayNewJO2: boolean;

  constructor(private auth: AuthenticationService) {
    this.addonFeature = this.auth.getAddonFeatureLists();
    /***********Check if the JO2 package is old or new ***********/
    var tenantPackagesJO2 = this.auth.getPackageCodeWithList("JO2"); // Get the tenant's package information
    // this.displayNewJO2 = true;
    if (localStorage.getItem("packageCode") == "Old") {
      // Check if the package is old
      this.displayNewJO2 = this.addonFeature.addonJO2 == "JO2" ? true : false;
    } else {
      if (this.auth.getAddonPackageListsToHide("JO2")) {
        this.displayNewJO2 =
          tenantPackagesJO2.addonPackageList == "JO2" ||
          this.addonFeature.addonJO2 == "JO2"
            ? true
            : false;
      } else {
        this.displayNewJO2 = false;
      }
    }
  }

  agInit(params: ICellRendererParams & ICellEditorParams): void {
    this.params = params;
    this.value = params.valueFormatted;
    console.log(params, "params printing in status component");

    if (this.displayNewJO2) {
      this.statusList =
        params.data?.jobOrder?.jobOrderType?.joTypeJOStatus! ?? [];
      this.isString = typeof this.value?.label;
      this.colorCode = this.value?.color;
    } else {
      this.value = params.value;
      this.statusList = JSON.parse(localStorage.getItem("joStatuses")! ?? "[]");
      this.isString = typeof this.value?.fieldLabel;
      this.colorCode = this.value?.colorCode;
    }

    if (params.value != null) {
      if (
        this.displayNewJO2
          ? params.value.label == undefined
          : params.value.fieldLabel == undefined
      ) {
        this.statusList.forEach((element: any) => {
          if (String(params.value) == String(element.name)) {
            this.value = element;
            this.isString = typeof this.value;
            //this.colorCode = this.value.colorCode ? this.value.colorCode : "";
            this.colorCode = this.value.colorCode ? this.value.colorCode : "";
            //this.label = this.value.fieldLabel;
            this.label = this.displayNewJO2
              ? this.value.label
              : this.value.fieldLabel;
          }
        });
      } else {
        this.value = this.displayNewJO2 ? params.valueFormatted : params.value;

        if (this.displayNewJO2) {
          if (this.value) {
            this.isString = typeof this.value.label;
            this.colorCode = this.value.color;
            this.label = this.value.label;
          } else {
            this.value = params.value;
            this.isString = typeof this.value;
            this.colorCode = params.value.colorCode
              ? params.value.colorCode
              : "";
            this.label = params.value.label;
          }
        } else {
          this.colorCode = this.value.colorCode ? this.value.colorCode : "";
          this.isString = typeof this.value;
          this.label = this.value.fieldLabel;
        }
      }
    }
  }

  refresh(params?: any): boolean {
    return true;
  }

  getValue(): any {
    return this.value?.label;
  }
}
